"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RIGHT_VARIANT = exports.LEFT_VARIANT = void 0;
var LEFT_VARIANT = 'left';
exports.LEFT_VARIANT = LEFT_VARIANT;
var RIGHT_VARIANT = 'right';
exports.RIGHT_VARIANT = RIGHT_VARIANT;